import React from "react";
import { motion } from "framer-motion";

const Portfolio = () => {
  // Daftar tulisan pilihan dari Medium kamu
  const articles = [
    { 
      title: "Berhitung", 
      topic: "Family", 
      excerpt: "Bahwa semakin banyak usia kita membuatku takut ...",
      link: "https://medium.com/@obywrites/berhitung-62146500ee01", // 
      image: "/posters/article1.jpg" 
    },
    { 
      title: "Perempuan Tanpa Bahasa Cinta", 
      topic: "Thoughts", 
      excerpt: "Tidak ada bahasa cinta yang kita kuasai, Bu ...",
      link: "https://medium.com/@obywrites/perempuan-tanpa-bahasa-cinta-dd66a2dd71e2", 
      image: "/posters/article2.jpg"
    },
    { 
      title: "Rahasia, tapi seseorang harus tahu", 
      topic: "Stories", 
      excerpt: "terima kasih tidak memaksaku membaca bersamamu...",
      link: "https://medium.com/@username/tulisan-3", 
      image: "/posters/article3.jpg"
    },
    {
      title: "Dari Membaca jadi Menulis", 
      topic: "Stories", 
      excerpt: "Ketika akhirnya kita punya sesatu untuk diungkapkan...",
      link: "https://medium.com/@obywrites/dari-membaca-jadi-menulis-ec51652f6288", 
      image: "/posters/article4.jpg"
    }
  ];

  return (
    <motion.div 
      className="category-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="category-header">
        <h2 className="main-title">Writing Portfolio 📝</h2>
        <p className="subtitle" style={{ marginBottom: "30px" }}>
          A collection of my thoughts, stories, and perspectives on Medium.
        </p>
        
        {/* Tombol Utama Fokus ke Medium */}
        <div style={{ marginTop: "20px" }}>
          <button 
            onClick={() => window.open("https://medium.com/@obywrites", "_blank")} 
            className="medium-btn"
            style={{ 
              padding: "12px 40px", 
              borderRadius: "30px", 
              border: "none", 
              backgroundColor: "#000", 
              color: "#fff", 
              fontWeight: "bold", 
              cursor: "pointer", 
              fontSize: "1rem",
              transition: "0.3s"
            }}
          >
            Visit My Medium Profile 📖
          </button>
        </div>
      </div>

      <div className="film-grid" style={{ marginTop: "60px" }}>
        {articles.map((article, i) => (
          <motion.div 
            key={i} 
            className="film-card-visual"
            whileHover={{ y: -10 }}
            onClick={() => window.open(article.link, "_blank")}
            style={{ cursor: "pointer" }}
          >
            <div className="poster-wrapper">
              <img 
                src={article.image} 
                alt={article.title} 
                onError={(e) => {e.target.src = "https://via.placeholder.com/400x300?text=Medium+Story"}}
              />
            </div>
            <div className="film-details">
              <span className="film-meta">{article.topic}</span>
              <h4 style={{ margin: "10px 0" }}>{article.title}</h4>
              <p className="film-desc" style={{ fontSize: "0.85rem", opacity: 0.8, lineHeight: "1.6" }}>
                {article.excerpt}
              </p>
              <p style={{ marginTop: "15px", fontWeight: "bold", fontSize: "0.8rem", color: "#000", textDecoration: "underline" }}>
                Read full story on Medium →
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Portfolio;